import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface IValueCard {
  icon: IconProp | IconDefinition;
  title: string;
  description: string;
}

const ValueCard: React.FC<IValueCard> = ({ icon, title, description }) => (
  <div className="flex flex-col justify-center items-center gap-[16px] pb-[26px]">
    <FontAwesomeIcon
      data-testid="value-card-icon"
      className="md:text-[70px] text-[36px] font-light"
      icon={icon}
      color="#0C5C95"
    />
    <h3 className="font-bold text-blue-600 font-avantgarde text-[16px] md:text-[20px] leading-[27px] md:leading-[39px]">
      {title}
    </h3>
    <p className="font-normal text-stone-800 font-body text-[14px] md:text-[16px] leading-[23.1px] md:leading-[26.4px] text-center">
      {description}
    </p>
  </div>
);

// eslint-disable-next-line import/no-default-export
export default ValueCard;
